import { defineMessages } from '../i18n/messages';

export const LocaleSelectorMessages = defineMessages({
  LABEL: {
    id: 'locale_selector.label',
    text: 'Language',
    description: 'Locale selector accessible label',
  },
});